import { EventEmitter } from "events";

class GlobalEventEmitter extends EventEmitter {
    constructor() {
        super();
        this.globalState = {
            selectedYcf: null
        };
    }

    setSelectedYcf(ycf) {
        this.globalState.selectedYcf = ycf;
        this.emit("cscz:selectYcf", ycf);
    }

    getSelectedYcf() {
        return this.globalState.selectedYcf;
    }
}

export default new GlobalEventEmitter();